export const SET_NAVSHOW = 'SET_NAVSHOW'
export const SET_IS_SHOW = 'SET_IS_SHOW'
export const SET_IMG_URL = 'SET_IMG_URL'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js